import {
  exams,
  exams_category,
  exams_category_select,
  subject_select,
  topic_select,
  level_select,
  course_select,
} from "@Modules/Exams/configs/constants";

import list_exams from "./reducers";
import list_exams_category from "./reducers/category";
import list_exams_category_select from "./reducers/cateSelect";
import list_topic_select from "./reducers/topicSelect";
import list_subject_select from "./reducers/subjectSelect";
import list_level_select from "./reducers/levelSelect";
import list_course_select from "./reducers/courseSelect";

export default {
  [exams]: list_exams,
  [exams_category]: list_exams_category,
  [exams_category_select]: list_exams_category_select,
  [topic_select]: list_topic_select,
  [subject_select]: list_subject_select,
  [level_select]: list_level_select,
  [course_select]: list_course_select,
};
